import { useState, useEffect } from "react";

import { Card, Col, Row, Typography, Button, Table, Avatar } from "antd";
import { FolderViewOutlined } from "@ant-design/icons";

import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import Spinner from "../components/common/Spinner/Spinner";
import jwtDecode from "jwt-decode";

function Home() {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));

  const { Title, Text } = Typography;

  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [administrators, setAdministrators] = useState([]);
  const [locations, setLocations] = useState([]);
  const [totalUsers, setTotalUsers] = useState();
  const [totalAdministrators, setTotalAdministraors] = useState();
  const [totalLocations, setTotalLocations] = useState();

  // table code start
  const columns = [
    {
      title: "USER",
      dataIndex: "name",
      key: "name",
      width: "32%",
    },

    {
      title: "ACTIVE",
      key: "status",
      dataIndex: "status",
    },
    {
      title: "COMPANY ID",
      key: "company",
      dataIndex: "company",
    },
  ];

  // table code start
  const columns2 = [
    {
      title: "USER",
      dataIndex: "name",
      key: "name",
      width: "32%",
    },

    {
      title: "ACTIVE",
      key: "status",
      dataIndex: "status",
    },
    {
      title: "COMPANY ID",
      key: "company",
      dataIndex: "company",
    },
  ];

  const data = users?.map((user) => {
    return {
      key: user?.id,
      name: (
        <>
          <Avatar.Group>
            {/*<Avatar*/}
            {/*  className="shape-avatar"*/}
            {/*  shape="square"*/}
            {/*  size={40}*/}
            {/*  src={face}*/}
            {/*></Avatar>*/}
            <div className="avatar-info">
              <Title level={5}>{user?.username}</Title>
              <p>{user?.email}</p>
            </div>
          </Avatar.Group>{" "}
        </>
      ),
      // function: (
      //   <>
      //     <div className="author-info">
      //       <Title level={5}>Inspector</Title>
      //       <p>Premium Security</p>
      //     </div>
      //   </>
      // ),

      status: (
        <>
          <Button
            className={user?.active ? "tag-primary" : "tag-badge"}
            style={{ cursor: "auto" }}
          >
            {user?.active ? <span>TRUE</span> : <span>FALSE</span>}
          </Button>
        </>
      ),
      company: (
        <>
          <div className="ant-employed">
            <span>{user?.company}</span>
            <Link
              style={{ marginLeft: "10px", color: "#1EC8FF" }}
              to={`user/${user?.id}`}
            >
              Edit
            </Link>
          </div>
        </>
      ),
    };
  });

  const data2 = administrators?.map((user) => {
    return {
      key: user?.id,
      name: (
        <>
          <Avatar.Group>
            {/*<Avatar*/}
            {/*  className="shape-avatar"*/}
            {/*  shape="square"*/}
            {/*  size={40}*/}
            {/*  src={face}*/}
            {/*></Avatar>*/}
            <div className="avatar-info">
              <Title level={5}>{user?.username}</Title>
              <p>{user?.email}</p>
            </div>
          </Avatar.Group>{" "}
        </>
      ),
      // function: (
      //   <>
      //     <div className="author-info">
      //       <Title level={5}>Inspector</Title>
      //       <p>Premium Security</p>
      //     </div>
      //   </>
      // ),

      status: (
        <>
          <Button
            className={user?.active ? "tag-primary" : "tag-badge"}
            style={{ cursor: "auto" }}
          >
            {user?.active ? <span>TRUE</span> : <span>FALSE</span>}
          </Button>
        </>
      ),
      company: (
        <>
          <div className="ant-employed">
            <span>{user?.company}</span>
            <Link
              style={{ marginLeft: "10px", color: "#1EC8FF" }}
              to={`user/${user?.id}`}
            >
              Edit
            </Link>
          </div>
        </>
      ),
    };
  });

  const columns3 = [
    {
      title: "LOCATION",
      dataIndex: "location",
      key: "location",
      // width: "25%",
    },
    {
      title: "ADDRESS",
      key: "address",
      dataIndex: "address",
    },
    {
      title: "CLIENT",
      key: "client",
      dataIndex: "client",
    },
    {
      title: "REGION",
      key: "region",
      dataIndex: "region",
    },
    {
      title: "COST CENTER",
      key: "costCenter",
      dataIndex: "costCenter",
    },
    {
      title: "EMAIL",
      key: "email",
      dataIndex: "email",
    },
  ];

  const data3 = locations?.map((location) => {
    return {
      key: location.id,
      location: (
        <>
          <Avatar.Group>
            <div className="avatar-info">
              <Title level={5}>{location.locationName}</Title>
              <p>{location.locationCoordinates}</p>
            </div>
          </Avatar.Group>{" "}
        </>
      ),

      address: (
        <>
          <div className="ant-employed">
            <span>{location.locationAddress}</span>
          </div>
        </>
      ),

      client: (
        <>
          <div className="ant-employed" style={{ cursor: "auto" }}>
            <strong>{location.client}</strong>
          </div>
        </>
      ),

      region: (
        <>
          <div className="ant-employed">
            <span>{location?.region}</span>
          </div>
        </>
      ),

      costCenter: (
        <>
          <div className="ant-employed">
            <span>{location.costCenter}</span>
          </div>
        </>
      ),

      email: (
        <>
          <div className="ant-employed">
            <span>{location.email}</span>
            <Link
              style={{ marginLeft: "10px", color: "#1EC8FF" }}
              to={`location/${location.id}`}
            >
              Edit
            </Link>
          </div>
        </>
      ),
    };
  });

  const administratorImage = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
        fill="#fff"
      ></path>
    </svg>,
  ];
  const userImage = [
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z"
        fill="#fff"
      ></path>
      <path
        d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z"
        fill="#fff"
      ></path>
      <path
        d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z"
        fill="#fff"
      ></path>
      <path
        d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z"
        fill="#fff"
      ></path>
    </svg>,
  ];

  const locationImage = <FolderViewOutlined />;

  const count = [
    {
      today: "Total Users",
      title: totalUsers,
      persent: "",
      icon: userImage,
      bnb: "bnb2",
    },
    {
      today: "Total Administrators",
      title: totalAdministrators,
      persent: "",
      icon: administratorImage,
      bnb: "bnb2",
    },
    {
      today: "Total Locations",
      title: totalLocations,
      persent: "",
      icon: locationImage,
      bnb: "bnb2",
    },
  ];

  const getUsers = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL+ "user/getAllUsers",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setUsers(
        response.data
          .filter((user) => user.roles.includes("ROLE_USER"))
          .slice(0, 5)
      );

      setTotalUsers(
        response.data.filter((user) => user.roles.includes("ROLE_USER")).length
      );

      setAdministrators(
        response.data
          .filter((user) => user.roles.includes("ROLE_ADMIN"))
          .slice(0, 5)
      );

      setTotalAdministraors(
        response.data.filter((user) => user.roles.includes("ROLE_ADMIN")).length
      );

      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getLocations = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL+ "location/getAllLocations",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setLocations(response.data.slice(0, 5));
      setTotalLocations(response.data.length);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    getUsers();
    getLocations();
  }, []);

  return (
    <>
      <div className="layout-content">
        {loading ? (
          <Spinner />
        ) : (
          <>
            <Row className="rowgap-vbox" gutter={[24, 0]}>
              {count.map((c, index) => (
                <Col
                  key={index}
                  xs={24}
                  sm={24}
                  md={8}
                  lg={8}
                  xl={8}
                  className="mb-24"
                >
                  <Card bordered={false} className="criclebox ">
                    <div className="number">
                      <Row align="middle" gutter={[24, 0]}>
                        <Col xs={18}>
                          <span>{c.today}</span>
                          <Title level={3}>
                            {c.title}{" "}
                            <small className={c.bnb}>{c.persent}</small>
                          </Title>
                        </Col>
                        <Col xs={6}>
                          <div className="icon-box">{c.icon}</div>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>

            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Latest Users"
              extra={
                <div style={{ display: "flex", flexDirection: "row" }}>
                  {/*<Input*/}
                  {/*    className="header-search"*/}
                  {/*    placeholder="Type here..."*/}
                  {/*    prefix={<SearchOutlined />}*/}
                  {/*/>*/}
                  {/*<Radio.Group style={{display: "flex", flexDirection: "row"}} onChange={onChange} defaultValue="a">*/}
                  {/*  <Radio.Button value="a">All</Radio.Button>*/}
                  {/*  <Radio.Button value="b">ONLINE</Radio.Button>*/}
                  {/*</Radio.Group>*/}
                </div>
              }
            >
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={data}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>

            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Latest Administrators"
              extra={
                <div style={{ display: "flex", flexDirection: "row" }}>
                  {/*<Input*/}
                  {/*    className="header-search"*/}
                  {/*    placeholder="Type here..."*/}
                  {/*    prefix={<SearchOutlined />}*/}
                  {/*/>*/}
                  {/*<Radio.Group style={{display: "flex", flexDirection: "row"}} onChange={onChange} defaultValue="a">*/}
                  {/*  <Radio.Button value="a">All</Radio.Button>*/}
                  {/*  <Radio.Button value="b">ONLINE</Radio.Button>*/}
                  {/*</Radio.Group>*/}
                </div>
              }
            >
              <div className="table-responsive">
                <Table
                  columns={columns2}
                  dataSource={data2}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>

            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Latest Locations"
              extra={
                <div style={{ display: "flex", flexDirection: "row" }}>
                  {/*<NavLink to="/add-location">*/}
                  {/*  <Button type="secondary" className="tag-primary">*/}
                  {/*    <PlusOutlined />*/}
                  {/*    Add Location*/}
                  {/*  </Button>*/}
                  {/*</NavLink>*/}
                  {/*<Input*/}
                  {/*    style={{ marginLeft: "20px" }}*/}
                  {/*    className="header-search"*/}
                  {/*    placeholder="Type here..."*/}
                  {/*    prefix={<SearchOutlined />}*/}
                  {/*/>*/}
                  {/*<Radio.Group style={{display: "flex", flexDirection: "row"}} onChange={onChange} defaultValue="a">*/}
                  {/*  <Radio.Button value="a">All</Radio.Button>*/}
                  {/*  <Radio.Button value="b">ONLINE</Radio.Button>*/}
                  {/*</Radio.Group>*/}
                </div>
              }
            >
              <div className="table-responsive">
                <Table
                  columns={columns3}
                  dataSource={data3}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </>
        )}
      </div>
    </>
  );
}

export default Home;
